import { useQuery, UseQueryResult } from 'react-query'

import { getRoutes } from '@src/Infrastructure/Connectors/GetRoutes/getRoutes'
import { GetRoutesError, GetRoutesParams, GetRoutesResponse } from '@src/Infrastructure/Types/GetRoutes'

export const queryFn = (params: GetRoutesParams) => async (): Promise<GetRoutesResponse> => {
    const result = await getRoutes(params)

    if ('errors' in result) {
        throw new Error(result.errors[0].code)
    }

    return result
}

export const getCacheKey = (params: GetRoutesParams) =>
    [
        'routes',
        params.currency,
        params.numberOfResults,
        params.originCountry ?? 'MISSING_ORIGIN_COUNTRY',
        params.originPort ?? 'MISSING_ORIGIN_PORT',
        params.originContinent ?? 'MISSING_ORIGIN_CONTINENT',
        params.destinationCountry ?? 'MISSING_DESTINATION_COUNTRY',
        params.destinationPort ?? 'MISSING_DESTINATION_PORT',
        params.destinationContinent ?? 'MISSING_DESTINATION_CONTINENT',
    ] as const

export type UseGetRoutes = (params: GetRoutesParams) => UseQueryResult<GetRoutesResponse, GetRoutesError>

export const useGetRoutes: UseGetRoutes = (params) => {
    return useQuery({
        queryFn: queryFn(params),
        queryKey: getCacheKey(params),
        enabled: false,
        retry: false,
    })
}
